import script from "./NativeDisplayReportsList.vue?vue&type=script&setup=true&lang=js"
export * from "./NativeDisplayReportsList.vue?vue&type=script&setup=true&lang=js"

import "./NativeDisplayReportsList.vue?vue&type=style&index=0&id=97dd793a&scoped=true&lang=css"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97dd793a"]])

export default __exports__